import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const puestoImporterSelectors = importerSelectors(
  'puesto.importer',
);

export default puestoImporterSelectors;
